import createModel, { prop } from './lib/create_model';
const AvailableLanguage = createModel({
  modelName: 'AvailableLanguage',
  properties: {
    id: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default AvailableLanguage;
